import React, { useId } from 'react'

interface ShopIconProps {
  className?: string
}

export const Shop: React.FC<ShopIconProps> = ({ className }) => {
  const id = useId()
  const paint0Id = `paint0_linear_${id}`
  const paint1Id = `paint1_linear_${id}`
  const paint2Id = `paint2_linear_${id}`
  const paint3Id = `paint2_linear_${id}`

  return (
    <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M29.5 5V3H26.8576C25.4998 3 24.3113 3.91198 23.9599 5.22352L20.1296 19.5177C19.8953 20.392 19.103 21 18.1978 21H8.26346C7.37051 21 6.58575 20.4081 6.34042 19.5495L4.32617 12.5L4 10.5H1.67383L4.62433 20.8243C4.99237 22.1122 6.16948 23 7.50885 23H18.9656C20.3234 23 21.512 22.088 21.8634 20.7765L25.6936 6.48235C25.9279 5.60799 26.7203 5 27.6255 5H29.5Z" fill={`url(#${paint0Id})`}/>
        <path d="M21.5 12.5L22 10.5H4L4.32617 12.5H21.5Z" fill={`url(#${paint1Id})`}/>
        <circle cx="8.5" cy="26.5" r="2.5" fill={`url(#${paint2Id})`}/>
        <circle cx="18.5" cy="26.5" r="2.5"fill={`url(#${paint3Id})`}/>
    <defs>
        <linearGradient id={paint0Id} x1="4.5" y1="12" x2="13.5" y2="33.5" gradientUnits="userSpaceOnUse">
            <stop stopColor="white"/>
            <stop offset="0.85" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id={paint1Id} x1="4.5" y1="12" x2="24" y2="16" gradientUnits="userSpaceOnUse">
            <stop stopColor="white"/>
            <stop offset="0.85" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id={paint2Id} x1="11.208" y1="23.5703" x2="11.208" y2="31.5" gradientUnits="userSpaceOnUse">
            <stop stopColor="white" stopOpacity="0"/>
            <stop offset="1" stopColor="white"/>
        </linearGradient>
        <linearGradient id={paint3Id} x1="21.208" y1="23.5703" x2="21.208" y2="31.5" gradientUnits="userSpaceOnUse">
            <stop stopColor="white" stopOpacity="0"/>
            <stop offset="1" stopColor="white"/>
        </linearGradient>
    </defs>
    </svg>
  )
}
